import React from "react";
import { DatePicker, Flex } from "antd";
import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";

const UpdateUnavailability = ({
  isOpen,
  message = "Select date",
  subMessage = "",
  btnLabel = "Ok",
  onSubmit = () => {},
}) => {
  const onChange = (data) => {
    console.log(data);
    onSubmit();
  };
  return (
    <ModalComponent isOpen={isOpen} width={347}>
      <Flex vertical gap="1rem" align="center">
        <div className="body-b1 text-center">{message}</div>
        <div className="body-b1 text-center">
          <DatePicker multiple onChange={onChange} maxTagCount="responsive" needConfirm />
        </div>
        <div>
          <ButtonComponent label={"Update"} type="primary" />
        </div>
      </Flex>
    </ModalComponent>
  );
};

export default UpdateUnavailability;
